import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VIcon,{attrs:{"color":_vm.color,"size":_vm.size}},[_vm._v("mdi-cart-outline")])}
var staticRenderFns = []

export { render, staticRenderFns }